export default __webpack_public_path__ + "static/media/stimulator.90696b20.webp";